import React from 'react';

interface Step {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  number: number;
  activeColor?: string;
  activeTextColor?: string;
  iconColor?: string;
  inactiveIconColor?: string;
}

interface StepIndicatorProps {
  currentStep: number;
  steps: Step[];
  progressColor?: string;
}

export function StepIndicator({ currentStep, steps, progressColor = 'bg-green-bb-2' }: StepIndicatorProps) {
  return (
    <div className="flex justify-center mb-8">
      <div className="relative w-full max-w-md">
        {/* Steps Container */}
        <div className="flex justify-between relative z-10">
          {steps.map((step) => {
            const IconComponent = step.icon;
            const isActive = currentStep >= step.number;
            const iconColorClass = isActive && step.iconColor
              ? step.iconColor
              : (step.inactiveIconColor || 'text-gray-200');
            
            return (
              <div key={step.number} className="flex flex-col items-center">
                <div className="mb-2">
                  <IconComponent 
                    className={`w-12 h-12 transition-all duration-300 ${iconColorClass}`}
                  />
                </div>
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-lg transition-all duration-300 ${
                    isActive
                      ? `${step.activeColor || 'bg-green-bb-2'} ${step.activeTextColor || 'text-white-bb'}`
                      : 'bg-gray-bb-4 text-gray-bb-2'
                  }`}
                >
                  {step.number}
                </div>
              </div>
            );
          })}
        </div>

        {/* Progress Line Background */}
        <div
          className="absolute h-0.5 bg-gray-bb-4 z-0"
          style={{ top: 'calc(3rem + 24px)', left: '24px', right: '24px' }}
        ></div>

        {/* Progress Line Active */}
        <div
          className={`absolute h-0.5 ${progressColor} transition-all duration-500 z-0`}
          style={{
            top: 'calc(3rem + 24px)',
            left: '24px',
            width: (() => {
              if (currentStep === 1) return '0%';
              const fraction = (currentStep - 1) / (steps.length - 1);
              return `calc(${fraction * 100}% - ${fraction * 48}px)`;
            })(),
          }}
        ></div>
      </div>
    </div>
  );
}
